exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.menu-pop{\n  top: 48px !important;\n  min-width: 140px;\n}\n.account-info{\n  z-index: 9 !important;\n}\n", ""]);

// exports
